import type { Features } from "byzantine/src/Feature";

export const TEMPLATES_ROUTE = "templates";
export const ACH_TEMPLATES_PATH = "ach";
export const DOMESTIC_WIRE_TEMPLATES_PATH = "wire";
export const INTERNATIONAL_WIRE_TEMPLATES_PATH = "international_wire";

export const areAchTemplatesAvailable = (
  features: Features
): boolean =>
  Boolean((features.ach_payments || features.ach_payments_collect) && features.ach_templates);

export const areDomesticWireTemplatesAvailable = (
  features: Features
): boolean => {
  if (!features.wires) {
    return false;
  }
  const val = features.wire_templates;
  return Boolean(Array.isArray(val) ? val.includes("fedwire") : val === "fedwire");
};

export const areInternationalWireTemplatesAvailable = (
  features: Features
): boolean => Boolean(features.international_wires && features.international_wire_templates);

export const areTemplatesAvailable = (
  features: Features
): boolean =>
  areAchTemplatesAvailable(features) ||
  areDomesticWireTemplatesAvailable(features) ||
  areInternationalWireTemplatesAvailable(features);
